/** Enhance the server-rendered collection fallback with Shopify's related products. */
class HenryRelatedProducts extends HTMLElement {
  connectedCallback() {
    if (this.dataset.performed === 'true' || this.observer) return;
    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.observer.disconnect();
      this.loadRecommendations();
    }, { rootMargin: '1200px 0px' });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.observer = null;
    this.controller?.abort();
  }

  async loadRecommendations() {
    this.controller = new AbortController();
    const timeout = setTimeout(() => this.controller.abort(), 8000);
    try {
      const response = await fetch(this.dataset.url, { signal: this.controller.signal });
      if (!response.ok) return;
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = document.querySelector('.pd-related__grid');
      const current = this.querySelector('.pd-related__grid');
      // Keep the fully usable fallback if the response is incomplete or the shopper is using a card.
      if (!current || !replacement || current.contains(window.document.activeElement)) return;
      if (replacement.querySelectorAll('.pd-related__product').length < current.querySelectorAll('.pd-related__product').length) return;
      // A late response must not swap cards once the shopper has reached the grid.
      if (current.getBoundingClientRect().top <= window.innerHeight) return;
      current.replaceWith(replacement);
      this.dataset.performed = 'true';
    } catch {
      // Network failures leave all server-rendered cards and links available.
    } finally {
      clearTimeout(timeout);
    }
  }
}

if (!customElements.get('henry-related-products')) {
  customElements.define('henry-related-products', HenryRelatedProducts);
}
